import { addCookieListener } from '@/lego/utils/navigator/cookies';

export default function boot(app) {
  // LinkedIn Insight Tag
  addCookieListener('cookies_accept_needed', function() {
    // Dependencias de Linkedin.
    window._linkedin_partner_id = '1871556';
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

    (function() {
      var s = document.getElementsByTagName('script')[0];
      var b = document.createElement('script');
      b.type = 'text/javascript';
      b.async = true;
      b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      s.parentNode.insertBefore(b, s);
    })();
  })
    // Linkedin cargado con éxito.
    .then(function() {
      console.log('¡Dependencias de Linkedin cargadas!');
    })

    // Error al cargar Linkedin.
    .catch(function(error) {
      console.error('Ha ocurrido un error:');
      console.error(error);
    });

  // End LinkedIn Insight Tag
}
